<app-modal [doubleWidth]="true">
  <app-modal-header
    style="z-index: 50"
    [title]="T.common.manage_widgets_and_layout | translate"
    [showDelete]="false"
    (closed)="bsModalRef.hide()"
  ></app-modal-header>

  <app-modal-body class="custom-scrollbar">
    <app-tabset #tabset [useTopBorder]="false" [tabId]="selectedTabId" (tabChanged)="tabChanged($event.id)">
      <app-tab id="customise">
        <ng-template appTabHeading>{{ T.dashboard.customize_layout | translate }}</ng-template>
        <app-dashboard-customise-layout
          [layout]="layout"
          [summaryBarWidgets]="summaryBarWidgets"
          [defaultWidgets]="defaultWidgets"
          [widgets]="widgets"
          [columns]="columns"
          (summaryBarUpdated)="summaryBarUpdated($event)"
          (dashboardLayoutUpdated)="dashboardLayoutUpdated($event)"
          (dashboardLayoutColumnsUpdated)="columnsUpdated($event)">
        </app-dashboard-customise-layout>
      </app-tab>
      <app-tab id="manage">
        <ng-template appTabHeading>{{ T.dashboard.manage_saved_views | translate }}</ng-template>
        <ng-container *ngTemplateOutlet="manageSavedViews"></ng-container>
      </app-tab>
    </app-tabset>
  </app-modal-body>

  <app-modal-footer>
    <app-button-rectangle
      class="button d-none d-md-block"
      [fitToContainer]="true"
      size="large"
      [text]="T.common.cancel | translate"
      buttonTheme="white"
      (clicked)="onClose()"
    ></app-button-rectangle>
    <ng-container *ngIf="selectedTabId === 'customise'">
      <app-button-rectangle
        class="button d-none d-md-block"
        [fitToContainer]="true"
        size="large"
        [text]="T.common.apply | translate"
        buttonTheme="primary"
        (clicked)="onSave()"
        [disabled]="!isDashboardLayoutEmpty() || !isLayoutChanged"
      ></app-button-rectangle>
    </ng-container>
    <ng-container *ngIf="selectedTabId === 'manage'">
      <app-button-rectangle
        class="button d-none d-md-block"
        [fitToContainer]="true"
        size="large"
        [text]="T.common.ok | translate"
        buttonTheme="primary"
        (clicked)="onClose()"
      ></app-button-rectangle>
    </ng-container>
  </app-modal-footer>
</app-modal>

<ng-template #manageSavedViews>
  <div class="modal-container">
    <div class="modal-info mt-2">
      <span class="modal-info-text">
        {{ T.common.customize_your_dashboard_by_dragging | translate }}
      </span>
    </div>
    <div class="saved-layouts-wrapper">
      <app-responsive-table
        [objects]="layouts"
        [tableHeaders]="tableHeaders"
        [selectableObjects]="false"
        [objectsPerPage]="50"
        [wholeRowSelection]="false"
        [adoptParentHeight]="false"
        [useSearch]="false"
      >
      </app-responsive-table>
    </div>
  </div>
</ng-template>

<ng-template #publicTemplate let-object="object">
  <ng-container *ngIf="object.public">
    <i class="material-symbols-outlined">public</i>
  </ng-container>
</ng-template>

<ng-template #actionsTemplate let-object="object">
  <ng-container *ngIf="!object.accountDefault">
    <div class="layouts-actions-container">
      <div class="action-delete" (click)="deleteLayout(object)">
        <i class="material-symbols-outlined action-icon">delete</i>
      </div>
    </div>
  </ng-container>
</ng-template>
